// AppNavBar.jsx
import { useMemo } from 'react';
import { CommandBar } from '@fluentui/react';
import { useHistory, useLocation } from 'react-router-dom';

const ROUTES = [
  { key: 'planner',   name: 'Workload Planner',   path: '/planner',   icon: 'PlanView' },
  { key: 'ai', name: "Ai Tools", path: '/ai', icon: 'ChatBot'},
  { key: 'people',    name: 'People',    path: '/people',    icon: 'ContactList' },
  { key: 'projects',  name: 'Projects',  path: '/projects',  icon: 'ProjectCollection' },
  { key: 'proposals', name: 'Proposals', path: '/proposals', icon: 'TextDocument' },
  { key: 'clients',   name: 'Clients',   path: '/clients',   icon: 'ContactCard' },
  { key: 'feedback', name: "Feedback", path: "https://compassrm.sharepoint.com/:x:/r/sites/1Proposals/Shared%20Documents/SAMPLE%20PROPOSALS%20-%20LOOK%20HERE/Proposals%20Database/RFPeasy%20Tickets.xlsx?d=w982e275c20f34b0fb140bfa9eb45a53d&csf=1&web=1&e=Tqn7pj", icon: "Feedback" }
];

export default function AppNavBar() {
  const history = useHistory();
  const location = useLocation();

  const items = useMemo(() => {
    // mark current route as "checked" so it's visually distinct
    return ROUTES.map(r => ({
      key: r.key,
      text: r.name,
      iconProps: { iconName: r.icon },
      onClick: (ev) => {
        ev?.preventDefault?.();
        if(r.key === 'feedback'){
          window.open(r.path);
          return;
        } else {
          history.push(r.path);
        };
        return;
      },
      // highlight if the URL starts with the route path
      // (so /projects/123 still highlights "Projects")
      checked: location.pathname === r.path || location.pathname.startsWith(r.path + '/'),
    }));
  }, [history, location.pathname]);

  return (
    <div style={{ position: 'sticky', top: 0, zIndex: 100, background: 'var(--white,#fff)' }}>
      <CommandBar
        items={items.slice(0,1)}
        farItems={items.slice(-6)}
        ariaLabel="Primary navigation"
        styles={{
          root: { borderBottom: '1px solid var(--neutralLight,#e1e1e1)' },
          // Make checked items a bit bolder/underlined
          primarySet: { selectors: { 'button[aria-checked="true"] .ms-Button-label': { fontWeight: 600, textDecoration: 'underline' } } },
        }}
      />
    </div>
  );
}
